import { post } from './api/web.service';

// User inquiry registration API  -  <IF-UM-SPRT-0001>
export const postUserInquiry = (payload) => {
  return post('/user/support', payload);
};
